import { Box, Paper, Typography } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { TCustomer } from "../../types/AllTypes";
import { MyButton } from "../MyButton";

export const CustomerLogin = ({
  saveCustomer
}: {
  saveCustomer: (customer: TCustomer) => void;
}) => {
  const [meno, setMeno] = useState("");
  const [cislo, setCislo] = useState("");

  const [errors, setErrors] = useState({
    meno: "",
    cislo: ""
  });

  const handleSave = () => {
    if (
      meno.length > 2 &&
      !meno
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .includes("slamka") &&
      !meno
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .includes("sucha trava") &&
      !cislo.trim().replace(/\s/g, "").toLowerCase().includes("910726446")
    ) {
      saveCustomer({
        meno: meno,
        cislo: cislo,
        id: uuidv4()
      });
    } else {
      setErrors({ ...errors, meno: "Prilis kratke" });
    }
  };

  return (
    <Box padding={1}>
      <Paper elevation={1} sx={{ padding: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          Prihlasit sa ako host
        </Typography>
        <TextField
          required
          error={errors.meno.length > 0}
          value={meno}
          onChange={e => {
            setMeno(e.target.value);
            setErrors({ ...errors, meno: "" });
          }}
          label="Meno"
          helperText={errors.meno}
          variant="standard"
          fullWidth
          onKeyDown={e => {
            if (e.key === "Enter") {
              handleSave();
            }
          }}
        />
        <TextField
          value={cislo}
          onChange={e => {
            setCislo(e.target.value);
          }}
          label="Tel. cislo"
          variant="standard"
          fullWidth
          onKeyDown={e => {
            if (e.key === "Enter") {
              handleSave();
            }
          }}
        />
        <Box width={"100%"} padding={2} right={0}>
          <MyButton
            fullWidth
            onClick={() => {
              handleSave();
            }}
          >
            <Typography
              sx={{
                fontWeight: 700
              }}
              variant="h6"
            >
              Prihlasit sa
            </Typography>
          </MyButton>
        </Box>
      </Paper>
      {/* <MyButton >Prihlasit sa</MyButton> */}
    </Box>
  );
};
